import { createContext, useContext } from 'react';

export const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const canEditEquipment = (role) => ['technician', 'admin', 'bu_manager'].includes(role);
export const canEditAccounting = (role) => ['accounting', 'admin'].includes(role);
export const canAccessAccounting = (role) => ['accounting', 'admin'].includes(role);
